<template>
    <b-card no-body>
        <v-table ref="table"
                 :items-provider="provider"
                 :fields="fields"
                 :excel-callback="exportExcel"
                 search
                 pagination="server">
                    <template #filters>
                        <successful-sales-report-filter v-on:filter="filter"></successful-sales-report-filter>
                    </template>
                    <template #custom-html>
                        <div class="row px-1 py-1">
                            <div class="col-md-3 mb-1">
                                <v-stats-box text="Toplam Tutar" variant="success" icon="currency_lira" :value="stats.TotalAmount || '0,00'"></v-stats-box>
                            </div>
                            <div class="col-md-3 mb-1">
                                <v-stats-box text="İşlem Adedi" variant="primary" icon="receipt_long" :value="stats.TotalCount || 0"></v-stats-box>
                            </div>
                            <div class="col-md-3 mb-1">
                                <v-stats-box text="Taksitli İşlem" variant="warning" icon="credit_card" :value="stats.InstallmentCount || 0"></v-stats-box>
                            </div>
                            <div class="col-md-3 mb-1">
                                <v-stats-box text="Güneş Ürün İşlem" variant="info" icon="wb_sunny" :value="stats.SunProductCount || 0"></v-stats-box>
                            </div>
                        </div>
                        <div class="row px-1 pb-1">
                            <div class="col-md-6 mb-1">
                                <b-card class="border mb-0">
                                    <h6 class="font-weight-bolder mb-1">Günlük Tahsilat Trendi</h6>
                                    <div class="chart-container">
                                        <app-echart-bar v-if="dailyChartData" :key="chartKey + '-daily'" :option-data="dailyChartData"></app-echart-bar>
                                        <div v-else class="text-center text-muted py-3">Veri yükleniyor...</div>
                                    </div>
                                </b-card>
                            </div>
                            <div class="col-md-6 mb-1">
                                <b-card class="border mb-0">
                                    <h6 class="font-weight-bolder mb-1">Plasiyer Bazlı Dağılım</h6>
                                    <div class="chart-container">
                                        <app-echart-bar v-if="plasiyerChartData" :key="chartKey + '-plasiyer'" :option-data="plasiyerChartData"></app-echart-bar>
                                        <div v-else class="text-center text-muted py-3">Veri yükleniyor...</div>
                                    </div>
                                </b-card>
                            </div>
                        </div>
                    </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ReportApi } from '@/api/report'
import SuccessfulSalesReportFilter from './components/SuccessfulSalesReportFilter.vue'
import VStatsBox from '@/components/VStatsBox.vue'
import AppEchartBar from '@/@core/components/charts/echart/AppEchartBar.vue'
import Additional from '@/utilities/additional'
import moment from 'moment'
export default {
    components:{
        BCard,
        SuccessfulSalesReportFilter,
        VStatsBox,
        AppEchartBar
    },
    data(){
        return {
            fields:[
                {name:'KOD',key:'PlasiyerCode',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'PLASİYER',key:'PlasiyerFullName',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'GÜN',key:'PaymentTime',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'ECZANE KODU',key:'CariCode',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'ECZANE İSMİ',key:'CariName',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'FATURA NO',key:'DocumentNo',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'GÜNEŞ ÜRÜN',key:'IsSunProductInvoice',thClass:'w-5',tdClass:'text-nowrap'},
                {name:'TAKSİT ORANI',key:'Installment',thClass:'w-5',tdClass:'text-nowrap'},
            ],
            filterData:{
                PaymentTimeStart: moment().startOf('month').format('YYYY-MM-DD'),
                PaymentTimeEnd: moment().endOf('month').format('YYYY-MM-DD'),
                PlasiyerId: null,
                CariCode: null,
                CariName: null,
                DocumentNo: null,
                IsSunProductInvoice: null,
                Installment: null,
                IsInstallment: null,
            },
            stats:{
                TotalAmount: '0,00',
                TotalCount: 0,
                InstallmentCount: 0,
                SunProductCount: 0
            },
            dailyChartData: null,
            plasiyerChartData: null,
            chartKey: 0
        }
    },
    mounted(){
        this.getStats()
    },
    methods:{
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
            this.getStats()
        },
        provider(data){
            return ReportApi.SuccessfulSalesReport({
                Pagination:data,
                ...this.filterData
            })
        },
        exportExcel(){
            this.$refs.table.setExcelLoading(true)
            ReportApi.SuccessfulSalesReportExport({
                ...this.filterData,
                QueryParam: this.$refs.table.searchValue
            }).then(res=>{
                const disposition = res.headers['content-disposition'] || ''
                let fileName = `BasariliSatisRaporu_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
                const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i)
                if(match && match[1]) fileName = decodeURIComponent(match[1])
                Additional.DownloadFile(res.data, fileName)
            }).finally(()=>{
                this.$refs.table.setExcelLoading(false)
            })
        },
        getStats(){
            this.dailyChartData = null
            this.plasiyerChartData = null

            ReportApi.SuccessfulSalesReportStats(this.filterData).then(res=>{
                const data = res.data.Data
                this.stats = {
                    TotalAmount: data.TotalAmount,
                    TotalCount: data.TotalCount,
                    InstallmentCount: data.InstallmentCount,
                    SunProductCount: data.SunProductCount
                }

                const formatAxis = (val) => {
                    if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M'
                    if (val >= 1000) return (val / 1000).toFixed(0) + 'K'
                    return val
                }

                const formatTooltip = (val) => {
                    return Number(val).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'
                }

                const tooltipConfig = {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: (params) => {
                        let label = params[0].axisValue
                        let value = formatTooltip(params[0].value)
                        return label + '<br/>' + params[0].marker + ' ' + value
                    }
                }

                this.chartKey++

                // Günlük tahsilat trendi
                this.dailyChartData = {
                    tooltip: tooltipConfig,
                    legend: { show: false },
                    grid: { left: '10px', right: '10px', top: '10px', bottom: '30px', containLabel: true },
                    xAxis: [{ type: 'category', data: data.DailyStats.map(d => d.Date), axisLabel: { fontSize: 11 }, axisTick: { alignWithLabel: true } }],
                    yAxis: [{ type: 'value', axisLabel: { formatter: formatAxis, fontSize: 11 } }],
                    series: [{
                        name: 'Tutar',
                        type: 'bar',
                        data: data.DailyStats.map(d => d.TotalAmount),
                        barCategoryGap: '20%',
                        itemStyle: { borderRadius: [4, 4, 0, 0] }
                    }]
                }

                // Plasiyer bazlı dağılım
                this.plasiyerChartData = {
                    tooltip: tooltipConfig,
                    legend: { show: false },
                    grid: { left: '10px', right: '10px', top: '10px', bottom: '5px', containLabel: true },
                    xAxis: [{ type: 'category', data: data.PlasiyerStats.map(p => p.PlasiyerName), axisLabel: { rotate: 45, fontSize: 9, interval: 0 }, axisTick: { alignWithLabel: true } }],
                    yAxis: [{ type: 'value', axisLabel: { formatter: formatAxis, fontSize: 11 } }],
                    series: [{
                        name: 'Tutar',
                        type: 'bar',
                        data: data.PlasiyerStats.map(p => p.TotalAmount),
                        barCategoryGap: '20%',
                        itemStyle: { borderRadius: [4, 4, 0, 0] }
                    }]
                }
            })
        }
    }
}
</script>

<style>
.chart-container {
    width: 100%;
    height: 300px;
}
.chart-container .echarts {
    width: 100% !important;
    height: 100% !important;
}
</style>
